"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProgressStatusList = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ProgressSectionModule = _interopRequireDefault(require("./ProgressSection.module.css"));
var _StatusToggler = _interopRequireDefault(require("./StatusToggler"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ProgressStatusList = exports.ProgressStatusList = {
  IDLE: "idle",
  ACTIVE: "active",
  COMPLETED: "completed",
  FAILED: "failed",
  SUCCEEDED: "succeeded",
  PENDING: "pending"
};
const ProgressSection = _ref => {
  let {
    progressNumber,
    progressText,
    progressStatus,
    onSectionClick
  } = _ref;
  const handleSectionClick = () => {
    onSectionClick?.(progressNumber, progressText, progressStatus);
  };
  return /*#__PURE__*/_react.default.createElement("li", {
    className: `${onSectionClick ? _ProgressSectionModule.default.clickableSection : ""}`,
    onClick: handleSectionClick
  }, /*#__PURE__*/_react.default.createElement(_StatusToggler.default, {
    progressStatus: progressStatus,
    progressNumber: progressNumber
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: _ProgressSectionModule.default.TabTitle
  }, progressText));
};
ProgressSection.propTypes = {
  progressNumber: _propTypes.default.number.isRequired,
  progressText: _propTypes.default.string.isRequired,
  progressStatus: _propTypes.default.oneOf(["idle", "active", "completed", "pending", "succeeded", "failed"]),
  onSectionClick: _propTypes.default.func
};
var _default = exports.default = ProgressSection;